import PropTypes from "prop-types";
import React, { PureComponent } from "react";

class SdsError extends PureComponent {
  render() {
    const { msg } = this.props;

    if (!msg) {
      return null;
    }

    return (
      <div className="sds-form-group sds-block sds-block--error">
        <p
          className="sds-p sds-color-error"
          dangerouslySetInnerHTML={{ __html: msg }}
          aria-live="assertive"
          role="alert"
        ></p>
      </div>
    );
  }
}

SdsError.propTypes = {
  msg: PropTypes.string,
};

export default SdsError;
